import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 19C20 19.7957 19.6837 20.5585 19.1211 21.1211C18.5585 21.6837 17.7957 22 17 22H7C6.20435 22 5.44151 21.6837 4.87891 21.1211C4.3163 20.5585 4 19.7957 4 19V5C4 4.20435 4.3163 3.44152 4.87891 2.87891C5.44152 2.3163 6.20435 2 7 2H14L14.0986 2.00488C14.3276 2.02757 14.5429 2.12883 14.707 2.29297L19.707 7.29297C19.8946 7.4805 20 7.73478 20 8V19ZM16.5859 7L15 5.41406V7H16.5859ZM6 19L6.00488 19.0986C6.02757 19.3276 6.12883 19.5429 6.29297 19.707C6.48051 19.8946 6.73478 20 7 20H17C17.2652 20 17.5195 19.8946 17.707 19.707C17.8946 19.5195 18 19.2652 18 19V9H15C14.4696 9 13.961 8.78913 13.5859 8.41406C13.2109 8.03899 13 7.53043 13 7V4H7C6.73478 4 6.4805 4.10543 6.29297 4.29297C6.10543 4.4805 6 4.73478 6 5V19Z",
		fill: "currentColor"
	})
});
export default SvgFile;
